<template>
  <el-dropdown-item id="btn-print-invoice-bulk-dropdown-item" v-if="isDropDownItem" type="success" plain
                    @click.native="handleExportCsv()" size="mini">
    <span class="more-actions-option">{{ $t('invoices.exportCsv') }}</span>
  </el-dropdown-item>
</template>

<script>
import { Loading, Message } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';

export default {
  name: 'ExportToCsv',
  props: {
    isDropDownItem: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['invoices'])
  },
  data() {
    return {};
  },
  methods: {
    async handleExportCsv() {
      if (this.invoices) {
        Message.closeAll();
        const loading = Loading.service(constants.LOADING.EXPORT_INVOICES_CSV_CONFIG);
        await this.$store.dispatch('invoices/exportToCsv');
        loading.close();
      }
    }
  },
};
</script>
<style rel="stylesheet/scss" lang="scss">
</style>
